export default __webpack_public_path__ + "static/media/background.5091c1dd.jpg";